const apiUrl = process.env.REACT_APP_API_URL;

export const webApiHijosMenu = `${apiUrl}/Servicio2/menu`
export const webApiObtiene = `${apiUrl}/Servicio2/menu_hijos`

export const webApiEscolaridad = `${apiUrl}/Servicio2/escolaridad`
export const webApiSexo = `${apiUrl}/Servicio2/sexo`
export const webApiNovedades= `${apiUrl}/Servicio2/recomendaciones_novedades`

export const webApiCarrusel = `${apiUrl}/Servicio2/carrusel`
export const webApiColecciones = `${apiUrl}/Servicio2/colecciones` 
export const webApiContacto = `${apiUrl}/Servicio2/contacto` 
export const webApiColeccionDetalle = `${apiUrl}/Servicio2/coleccion_detalle` 

export const webApiIntroduccionColeccion = `${apiUrl}/Servicio2/introduccion_colecciones`
export const webApiIntroduccionAcercaDe = `${apiUrl}/Servicio2/introduccion_acerca_de`
export const webApiContenidoAcercaDe = `${apiUrl}/Servicio2/contenido_acerca_de`

export const webApiIntroduccionAutores = `${apiUrl}/Servicio2/introduccion_autores`
export const webApiAutoresIndice= `${apiUrl}/Servicio2/autores_indice`

export const webApiContenidoSeccion= `${apiUrl}/Servicio2/contenido_seccion`

export const webApiAutoresLista= `${apiUrl}/Servicio2/autores_lista`
export const webApiContenidoSeccionTotal= `${apiUrl}/Servicio2/contenido_seccion_total`
export const webApiAutoresDetalle= `${apiUrl}/Servicio2/autores_detalle`

export const webApiObra= `${apiUrl}/Servicio2/obras`
export const webApiCapitulos= `${apiUrl}/Servicio2/capitulos`
export const webApiLicencia= `${apiUrl}/Servicio2/licencia`

export const webApiBusqueda= `${apiUrl}/Busquedas/sencilla`
export const webApiBusquedaAvanzada= `${apiUrl}/Servicio2/busquedaAvanzada`
export const webApiConteoSencillo= `${apiUrl}/Busquedas/conteo_sencillo`
export const webApiConteoAvanzado= `${apiUrl}/Servicio2/conteo_avanzado`
export const webApiFiltrosPredecibles= `${apiUrl}/Busquedas/filtros_predecibles`
export const webApiFiltrosPredeciblesAvanz= `${apiUrl}/Servicio2/filtros_predecibles_avanz`

export const webApiInputAutores= `${apiUrl}/Servicio2/input_autores`
export const webApiInputColecciones= `${apiUrl}/Servicio2/input_colecciones`
export const webApiInputTemas= `${apiUrl}/Servicio2/input_temas`
export const webApiInputAnios= `${apiUrl}/Servicio2/input_anios`



export const pathImages = process.env.REACT_APP_PATH_IMAGES;
export const pathPDF = process.env.REACT_APP_PATH_PDF;
export const nombreSitio = process.env.REACT_APP_SITIO_NOMBRE;
